import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import "../dashboard/css/profilepage.css";

import {
  FaEnvelope,
  FaBullhorn,
  FaQuestionCircle,
  FaHandsHelping,
  FaBriefcase,
  FaShieldAlt,
  FaLightbulb,
  FaSignInAlt,
  FaRupeeSign,
  FaBuilding
} from "react-icons/fa";

import Helpmodel from "../dashboard/HelpModal";
import GetLeadsModal from "./GetLeadsModal";
import { getLoggedCompany, logout } from "../../utils/auth.js";
import profileIcon from "../../../src/main/dashboard/assets/profile.png";

const ProfilePage = () => {
  const history = useHistory();

  const [openHelp, setOpenHelp] = useState(false);
  const [openLeads, setOpenLeads] = useState(false);
  const [company, setCompany] = useState(null);

  // ✅ Load logged-in company
  useEffect(() => {
    const data = getLoggedCompany();
    setCompany(data);
  }, []);

  const handleClose = () => {
    const container = document.querySelector(".profile-container");
    if (container) {
      container.classList.add("slide-out");
      setTimeout(() => history.push("/"), 400);
    } else {
      history.push("/");
    }
  };

  const profileImage = company?.photo_url
    ? `${process.env.REACT_APP_API_URL}${company.photo_url}`
    : profileIcon; // add default image in public/

  return (
    <>
      <div className="profile-container">
        <div className="profile-card">
          {/* HEADER */}
          <div className="profile-header">
            <button className="close-btn" onClick={handleClose}>×</button>

            <div className="profile-info">
              <div
                className="profile-avatar"
                style={{
                  backgroundImage: `url(${profileImage})`,
                }}
              />

              <h3>{company ? company.name : "Welcome"}</h3>

              <p className="profile-sub">
                {company
                  ? company.company_name
                  : "Sign in to personalize your experience"}
              </p>

              {company && (
                <div className="profile-tags">
                  <button>Saved</button>
                  <button>Favorites</button>
                  <button>Interests</button>
                </div>
              )}
            </div>
          </div>

          {/* MENU */}
          <div className="profile-menu">
            <Link to="/agency" className="jd-link agency-highlight">
  <FaBuilding />
  <span>Agency</span>
</Link>
            <div
              className="menu-item"
              onClick={() => setOpenLeads(true)}
              style={{ cursor: "pointer" }}
            >
              <FaEnvelope className="menu-icon" />
              <span>Leads</span>
            </div>

            <GetLeadsModal
              open={openLeads}
              onClose={() => setOpenLeads(false)}
            />

            <Link to="/business-listing" className="menu-link">
              <div className="menu-item">
                <FaBullhorn className="menu-icon" />
                <span>List your Business</span>
                <span className="free-badge">Free</span>
              </div>
            </Link>

            <Link to="/pricing" className="menu-link">
              <div className="menu-item">
                <FaRupeeSign className="menu-icon" />
                <span>Plans</span>
              </div>
            </Link>

            {/* 🔥 LOGIN / LOGOUT SWITCH */}
            {!company ? (
              <Link to="/login" className="menu-link">
                <div className="menu-item">
                  <FaSignInAlt className="menu-icon" />
                  <span>Login</span>
                </div>
              </Link>
            ) : (
              <div
                className="menu-item"
                onClick={logout}
                style={{ cursor: "pointer", color: "#ef4444" }}
              >
                <FaSignInAlt className="menu-icon" />
                <span>Logout</span>
              </div>
            )}

            <div className="menu-item">
              <FaBullhorn className="menu-icon" />
              <span>Advertise</span>
            </div>

            <Link to="/Customerservice" className="menu-link">
            <div className="menu-item">
              <FaQuestionCircle className="menu-icon" />
              <span>Customer Service</span>
            </div>
            </Link>

            <div
              className="menu-item"
              onClick={() => setOpenHelp(true)}
              style={{ cursor: "pointer" }}
            >
              <FaHandsHelping className="menu-icon" />
              <span>Help</span>
            </div>

            <div className="menu-item">
              <FaBriefcase className="menu-icon" />
              <span>Settings</span>
            </div>

            <Link to="/privacypolicy" className="menu-link">
              <div className="menu-item">
                <FaShieldAlt className="menu-icon" />
                <span>Privacy Policy</span>
              </div>
            </Link>

            <div className="menu-item">
              <FaLightbulb className="menu-icon" />
              <span>What&apos;s New</span>
            </div>
          </div>
        </div>
      </div>

      <Helpmodel isOpen={openHelp} onClose={() => setOpenHelp(false)} />
    </>
  );
};

export default ProfilePage;
